<template>
  <MainLayout>
    <div class="cupom-view" v-if="campaign.gears && campaign.gears.control">
      <div class="top-title">
        <h1>Cupom</h1>
      </div>

      <div class="cupom-content">
        <h2 v-if="cupom.status === 'ACTIVE'">Apresente seu QRCode no stand
          <br><br>
          <template v-if="campaign.gears.type_gift.customer_can_exchange && cupom.status === 'ACTIVE'">
            <span>ou resgate você mesmo apertando no botão abaixo</span>
            <button class="primary" @click="exchangeCoupon">Resgatar</button>
          </template>
        </h2>

        <hr style="margin: 20px 0" v-if="cupom.status === 'ACTIVE'" />

        <div class="left">
          <center v-if="cupom.status === 'ACTIVE'">
            <qrcode-vue :value="qrcode" :size="250" v-if="qrcode"></qrcode-vue>
            <div class="img-empty" v-else></div>
          </center>

          <div v-if="cupom.status === 'EXCHANGED'">
            <h2>Brinde resgatado</h2>
            
          <div class="product-item">
            <div class="image-box" v-if="cupom.product.images && cupom.product.images[0]">
              <img :src="getImageThumbUrl(cupom.product.images[0])" alt="" />
            </div>
            <div class="img-empty" v-else></div>
            <div class="info">
              <h3>{{ cupom.product.name }}</h3>
            </div>
          </div>

          </div>

        </div>

        <div class="cupom-info right">
          <table>
            <tr>
              <td class="label">Número</td>
              <td>{{ cupom.number }}</td>
            </tr>
            <tr>
              <td class="label">Criação</td>
              <td v-if="cupom.created_at">{{ cupom.created_at | formatDateTime }}</td>
            </tr>
            <tr>
              <td class="label">Troca</td>
              <td v-if="cupom.status == 'EXCHANGED'">{{ cupom.updated_at | formatDateTime }}</td>
              <td v-else-if="cupom.status == undefined"></td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td class="label">Status</td>
              <td>{{ ticketStatusOptions[cupom.status] }}</td>
            </tr>
          </table>
        </div>
      </div>


      <center>
        <button class="primary" @click="historyBack">Voltar</button>
      </center>


    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "../layout/main";
import OrderMixin from "../mixins/order.mixin.js";

import CampaignMixin from "../mixins/campaign.mixin.js";
import userMixin from "../mixins/user.mixin";

import QrcodeVue from 'qrcode.vue'

import "../filters/toCurrency";

export default {
  mixins: [CampaignMixin, userMixin, OrderMixin],
  components: {
    MainLayout,
    QrcodeVue
  },
  data() {
    return {
      tab: "bill",
      notaStatus: ["Erro", "Aprovada", "Rejeitada", "Processando"],
      qrcode: null,
      cupom: {
        company: null,
        campaign: null,
        user: null,
        product: null,
        invoice: null,
        type: 'CUPOM',
        number: '',
        status: 'ACTIVE',
        bonus: {
          is_bonus: false,
          generative: ''
        },
        log: [],
        created_at: null,
        updated_at: null,
      },
      ticketStatusOptions: {
        ACTIVE: 'Ativo',
        PRINTED: 'Impresso',
        EXCHANGED: 'Trocado',
        CANCELED: 'Cancelado',
        CANCEL: 'Cancelado'
      },
      orders: [],
      listMessage: "Carregando",
      listMessagePayment: "Carregando",
    };
  },
  mounted: function () {
    let self = this;
    var id = this.$route.params.id;
    this.getTicket(id).then(function (response) {
      console.log(response)
      self.cupom = response.ticket;
      self.qrcode = JSON.stringify({
        ticket: self.cupom._id,
        user: self.cupom.user._id,
      })

    })
  },
  methods: {
    exchangeCoupon() {
      window.open(this.campaignHome + '/resgate-brindes/' + this.cupom._id, "_self")
    }
  }
};
</script>

<style scoped lang="scss">
@import "../scss/colors.scss";

.cupom-view {
  padding-bottom: 150px;
}

.cupom-content {
  height: 100%;
  padding: 20px 10px 0px 20px;
  margin-bottom: 0px;

  justify-content: space-evenly;

  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-flow: row wrap;
  margin-bottom: 50px;
  padding: 20px;
  gap: 40px;

  h2 {
    text-align: center;
  }

  .image {
    width: 80%;
    max-width: 420px;
    min-height: 400px;
    background: var(--bg-color-dark);
    display: block;
    margin: auto;
  }

  // overflow-y: scroll;

  h1.info {
    margin-top: 36vh;
    font-size: 20px;
    color: $primary-light;
  }

  .cupom-info {
    background: var(--bg-color-dark);
    padding: 50px 30px;

    table {
      width: 100%;

      td {
        padding: 10px 0px;
        text-align: left;

        &.label {
          font-weight: bold;
          color: var(--primary);
        }
      }
    }
  }
}

.left {
  width: calc(45% - 20px);

  
  .product-item {
    margin-top: 20px;
    background: var(--bg-color-light);
    position: relative;
    aspect-ratio: 1 / 1;
    cursor: pointer;
    border: 3px solid transparent;
    border-radius: 5px;
    overflow: hidden;

    &.selected {
      border-color: var(--primary);
    }

    .image-box {
      width: 100%;
      height: 100%;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .img-empty {
      width: 100%;
      height: 100%;
      background-color: var(--bg-color-dark);
    }

    .info {
      position: absolute;
      bottom: 0px;
      width: 100%;
      padding: 10px;
      background: var(--secundary);

      h3 {
        font-size: 13pt;
        font-weight: bold;
        color: #000;
      }
    }
  }
}

.right {
  width: calc(55% - 20px);
}

@media (max-width: 768px) {
  .cupom-content {
    padding: 20px 0px !important;

    .left {
      width: 100%;
    }

    .right {
      width: 100%;
    }
  }
}
</style>